import React, { useState } from "react";
import { Link, NavLink, useParams } from "react-router-dom";

function Navbar() {
  const [active, setActive] = useState(false);
  return (
    <div>
      <div className="banner">
        <div className="box">
          <span />
        </div>
        <div id="menu" className={active && "active"}>
          <div className="item__bar">
            <h1>Ташкентский Фармацевтический Институт</h1>
            <p>
              При использовании информации с сайта ссылка на источник
              обязательна.
            </p>
            <div className="bottomer">
              <span>Интерактивные услуги</span>
              <span>Прием ректора</span>
              <span>Связаться</span>
            </div>
            <div className="icon__menu">
              <div className="item__icon">
                <img src="/assets/img/moodle.png" alt />
                <span>Moodle</span>
              </div>
              <div className="item__icon">
                <img src="/assets/img/student.png" alt />
                <span>Hemis student</span>
              </div>
              <div className="item__icon">
                <img src="/assets/img/teacher.png" alt />
                <span>Hemis teacher</span>
              </div>
              <div className="item__icon">
                <img src="/assets/img/library.png" alt />
                <span>Library</span>
              </div>
            </div>
          </div>
          <div
            className="item__close"
            id="close_menu"
            onClick={() => setActive(false)}
          ></div>
        </div>
      </div>
      <nav>
        <div className="card">
          <div className="ciz" id="toggle" onClick={() => setActive(true)}>
            ☰
          </div>
          <ul>
            <li>
              <a href="#">Институт</a>
              <div className="context">
                <Link to={'/about'}>Об ТашФармИ</Link>
                <Link to={'/rektorat'}>Ректорат</Link>
                <Link to={'/kofedra'}>Кафедры</Link>
                <Link to={'/'}>Центры и отделы</Link>
                <Link to={'/academic'}>Академический лицей</Link>
                <Link to={'/dvsim'}>DVSIM</Link>
                <Link to={'/'}>Cтруктура института</Link>
                <Link to={'/'}>Правила этикета</Link>
                <Link to={'/'}>Стратигический план</Link>
              </div>
            </li>
            <li>
              <a href="#">Прием</a>
              <div className="context">
                <Link to={'/'}>Обзор приема</Link>
                <Link to={'/'}>Первокурсникам</Link>
                <Link to={'/'}>Иностранным студентам</Link>
                <Link to={'/'}>Консультация</Link>
                <Link to={'/'}>FAQ</Link>
              </div>
            </li>
            <li>
              <a href="#">Студентам</a>
              <div className="context">
                <Link to={'/'}>	Бакалавриат</Link>
                <Link to={'/'}>	Магистратура</Link>
                <Link to={'/'}>	Факультеты и направления</Link>
                <Link to={'/'}>	Библиотека</Link>
                <Link to={'/'}>	Регистрация на курсы</Link>
                <Link to={'/'}>	Выпускникам</Link>
                <Link to={'/'}>	Переквалификация студентам</Link>
                
              </div>
            </li>
            <li>
              <a href="#">Деятельность</a>
              <div className="context">
                <Link to={'/innovation'}>	Исследования и Инновации </Link>
                <Link to={'/nationalactive'}>	Международное сотрудничество  </Link>
                <Link to={'/'}>	Финансовая деятельность</Link>
                <Link to={'/socialactive'}>	Социальная деятельность</Link>
              </div>
            </li>
            <li>
              <a href="#">Международная деятельность</a>
              <div className="context">
              <Link to={'/interContact'}>	Международный отдел </Link>
                <Link to={'/interpartners'}>	Международные партнёры   </Link>
                <Link to={'/hope'}>		El yurt umidi </Link>
              </div>
            </li>
            <li>
              <a href="#">Студенческая жизнь</a>
              <div className="context">
                <Link to={'/'}>Обзор студенческой жизни </Link>
                <Link to={'/'}>Жизнь в кампусе </Link>
                <Link to={'/'}>Дух и традиции </Link>
                <Link to={'/'}>Студенческие истории </Link>
               
              </div>
            </li>
            <li>
              <NavLink to={"/about"}>O нас</NavLink>
              <div className="context">
                <Link to={'/'}>Контакты </Link>
                <Link to={'/'}>История института </Link>
                <Link to={'/'}>Местный партнеры </Link>
                <Link to={'/'}>Международный партнеры </Link>
              </div>
            </li>
          </ul>
          <div className="group__btn">
            <button>UZ</button>
            <button>RU</button>
            <button>EN</button>
          </div>
        </div>
        <div className="card-1">
          <div className="bay">
            <NavLink to={"/"}>
              <img src="/assets/img/logo.svg" alt />
            </NavLink>
          </div>
          <div className="inb">
            <input type="text" placeholder="Что вы ищете?" />
            <button>Найти</button>
          </div>
        </div>
      </nav>
    </div>
  );
}

export default Navbar;
